// extracted by mini-css-extract-plugin
export var serviceCardBase = "service-card-base-module--service-card-base--zEvEg";
export var serviceCardBaseContent = "service-card-base-module--service-card-base--content--MqZBO";